import { Link } from "gatsby";
import { useGalleryContext } from "../context/Context";

const Navbar = () => {
  const { sidebarToggle } = useGalleryContext();

  return (
    <nav className="navbar">
      <div className="nav-center">
        <div className="nav-header">
          <Link to="/">
            <h3 className="nav-header__text">Николай Крутов</h3>
          </Link>
          <button className="nav-button" onClick={sidebarToggle}>
            <div className="nav-btn">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </button>
        </div>
        <div className="nav-links show-links">
          <Link
            to="/"
            className="nav-link"
            activeClassName="active-link">Главная</Link>
          <Link
            to="/artworks"
            className="nav-link"
            activeClassName="active-link">Картины</Link>
          <Link
            to="/about"
            className="nav-link"
            activeClassName="active-link">Биография</Link>
          <Link
            to="/contact"
            className="nav-link"
            activeClassName="active-link">Контакты</Link>
          {/* <Link to="/test" className="nav-link lang-link">
            <button>En</button> / <button>Ru</button>
          </Link> */}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
